import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';
import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';
import { wrapPromiseWithFetchInteraction } from '@atlassian/jira-polaris-lib-analytics/src/common/utils/interaction/index.tsx';
import type { IssueTypesForProjectsResponse } from './types.tsx';
import { getEarlyFetchResponse } from './early-scripts/index.tsx';
import { getIssueTypesForProjectsUrl } from './utils.tsx';

export const performGetIssueTypesForProjects = (
	projectIds: ProjectId[],
): Promise<IssueTypesForProjectsResponse> => {
	if (!projectIds.length) {
		throw new Error('No project ids provided');
	}

	// Try to get from early fetch cache first
	const earlyFetchResponse = getEarlyFetchResponse(projectIds);
	if (earlyFetchResponse) {
		return wrapPromiseWithFetchInteraction(
			earlyFetchResponse,
			'earlyScript/getIssueTypesForProjects',
		).catch(() => {
			// If the cached promise fails, fall back to a regular fetch
			return fetchJson<IssueTypesForProjectsResponse>(getIssueTypesForProjectsUrl(projectIds));
		});
	}

	// Fallback to regular fetch if not in cache
	return fetchJson<IssueTypesForProjectsResponse>(getIssueTypesForProjectsUrl(projectIds));
};
